exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html {\n  position: relative;\n  overflow-x: hidden;\n}\n\nbody {\n  overflow-x: hidden;\n  margin-bottom: 6px;\n}\n\n.row {\n  margin: 0 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/styles.css
// module id = 370
// module chunks = 2